import * as searchUMLSTermsTypes from '../action-types/searchUMLSTermsActionTypes';

const initialState = {
  selectedTerms: [],
  umlsData: [],
  errorMsg: '',
  loading: false,
  notFound: false,
  user: null,
  termsStatus: '',
  inputTerm: '',
  inputCui: '',
  input: '',
  guidelineId: '',
  termIds: '',
  atomsData: [],
  termClicked: '',
  termsSelectedPage: 0,
};

const umlsReducer = (state = initialState, action) => {
  switch (action.type) {
    case searchUMLSTermsTypes.UPDATE_SEARCH_SELECTION: {
      return {
        ...state,
        termsStatus: action.value,
      };
    }
    case searchUMLSTermsTypes.UPDATE_INPUT_TERM: {
      return {
        ...state,
        inputTerm: action.value,
        inputCui: '',
      };
    }
    case searchUMLSTermsTypes.UPDATE_INPUT_CUI: {
      return {
        ...state,
        inputCui: action.value,
        inputTerm: '',
      };
    }
    case searchUMLSTermsTypes.SEARCH_TERMS_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case searchUMLSTermsTypes.SEARCH_TERMS_SUCCEEDED: {
      let data;
      if (Array.isArray(action.value)) {
        data = [...state.umlsData, ...action.value];
      } else {
        data = action.value;
      }
      return {
        ...state,
        umlsData: data,
        input: action.input,
        notFound: false,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.SEARCH_TERMS_FAILED: {
      return {
        ...state,
        notFound: true,
        loading: false,
        umlsData: [],
      };
    }
    case searchUMLSTermsTypes.SAVE_TERMS_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case searchUMLSTermsTypes.SAVE_TERMS_SUCCEEDED: {
      return {
        ...state,
        selectedTerms: [...state.selectedTerms, action.value],
        notFound: false,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.SAVE_TERMS_FAILED: {
      return {
        ...state,
        notFound: true,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.SAVE_INDEXINGTERMS_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case searchUMLSTermsTypes.SAVE_INDEXINGTERMS_SUCCEEDED: {
      return {
        ...state,
        selectedTerms: action.value,
        notFound: false,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.FETCH_TERMS_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case searchUMLSTermsTypes.FETCH_TERMS_FAILED: {
      return {
        ...state,
        notFound: true,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.FETCH_TERMS_SUCCEEDED: {
      return {
        ...state,
        selectedTerms: action.value,
        notFound: false,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.SEARCH_ATOMS_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case searchUMLSTermsTypes.SEARCH_ATOMS_SUCCEEDED: {
      return {
        ...state,
        atomsData: action.value,
        notFound: false,
        loading: false,
      };
    }
    case searchUMLSTermsTypes.SEARCH_ATOMS_FAILED: {
      return {
        ...state,
        notFound: true,
        loading: false,
        atomsData: [],
      };
    }
    case searchUMLSTermsTypes.CLEAR_ATOMS_DATA: {
      return {
        ...state,
        atomsData: [],
      };
    }
    case searchUMLSTermsTypes.CLEAR_SELECTED_TERMS: {
      return {
        ...state,
        selectedTerms: [],
      };
    }
    case searchUMLSTermsTypes.CLEAR_SEARCHED_TERMS: {
      return {
        ...state,
        umlsData: [],
      };
    }
    case searchUMLSTermsTypes.TERM_CLICKED: {
      return {
        ...state,
        termClicked: action.value,
      };
    }
    case searchUMLSTermsTypes.TERM_DIALOG_CLOSED: {
      return {
        ...state,
        termClicked: '',
      };
    }
    case searchUMLSTermsTypes.TERMS_PAGE_SELECTED: {
      return {
        ...state,
        termsSelectedPage: action.value,
      };
    }
    default: {
      return state;
    }
  }
};

export default umlsReducer;
